import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'web-di-ld-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {
  @Input() title: string = '';
  @Input() path: string =
    '/assets/images/foundationIllustrationGenericError.png';
  @Input() img: string = '';
  @Input() case: string | number = 1;
  @Output() clickEvt = new EventEmitter();

  constructor() {}

  ngOnInit(): void {
    if (this.img == 'sadBird') {
      this.path =
        '/assets/images/foundation-illustration-contextual-vayu-application-fail.png';
    }
  }

  emitClickEvt() {
    this.clickEvt.emit();
  }
}
